import {
  TileLayer, 
  BitmapLayer, 
  TerrainLayer, 
  TextLayer,
  ScatterplotLayer,
 } from 'deck.gl';

function heightToRGB(height) {
  // X = 10 * height + 100000
  const X = 10 * height + 100000;

  // R = floor(X / (256 * 256))
  const R = Math.floor(X / (256 * 256));

  // G = floor((X - R * 256 * 256) / 256)
  const G = Math.floor((X - R * 256 * 256) / 256);

  // B = X - R * 256 * 256 - G * 256
  const B = X - R * 256 * 256 - G * 256;

  return { R, G, B };
}

const convertDemTiffData = (geotiffData, width, height) => {
  const value = geotiffData[0];
  const canvas = document.createElement("canvas");
  //const canvas = document.querySelector("#canvas")

  canvas.width = width;
  canvas.height = height;

  const ctx = canvas.getContext("2d");

  const pix = new Uint8ClampedArray(width * height * 4);


  //バンド値をカラー値に変換してピクセルに転写する
  for (let i = 0; i < width * height * 4; i++) {
    const rgb = heightToRGB(value[i]);
    pix[i * 4] = rgb.R;
    pix[i * 4 + 1] = rgb.G;
    pix[i * 4 + 2] = rgb.B;
    pix[i * 4 + 3] = 255;
  }

  const newImage = new ImageData(pix, width, height);

  ctx.putImageData(newImage, 0, 0);
  

  const url = ctx.canvas.toDataURL();

  return url
}

const textData = [
  { name: "everest", label: "Everest", coordinates: [138.75 - 1.2, 35.3624269, 14000]},
  { name: "k2", label: "K2", coordinates: [138.75 - 0.9 - 0.005, 35.3624269, 14000]},
  { name: "kangchenjunga", label: "Kangchenjunga", coordinates: [138.75 - 0.6, 35.3624269, 14000] },
  { name: "kinabalu", label: "Mt.Kinabalu", coordinates: [138.75 - 0.3, 35.3624269, 6000] },
  { name: "fuji", label: "Mt.Fuji", coordinates: [138.75 - 0.025, 35.3624269, 6000]},
  { name: "semeru", label: "Mt.Semeru", coordinates: [138.75 + 0.3 - 0.025, 35.3624269, 6000] },
]

const translate = {
  everest: [-1.2, 0, 0],
  k2:[-0.9, 0, 0],
  kangchenjunga:[-0.6, 0, 0],
  kinabalu: [-0.3, 0, 0],
  lhotse:[-0.3, 0, 0],
  fuji: [0, 0, 0],
  semeru: [0.3, 0, 0],
}

const latlng = {
  everest: [27.988056, 86.925278].reverse(),
  k2: [35.8825, 76.513333].reverse(),
  kangchenjunga: [27.7, 88.133333].reverse(),
  kinabalu: [6.083333, 116.55].reverse(),
  lhotse: [27.966667, 86.933333].reverse(),
  fuji: [35.3606, 138.7275].reverse(),
  semeru: [-8.108, 112.92].reverse(),
  
}


export function renderLayers({ tiffData, selectPoint }) {
 
  if (!tiffData) return null;

  let layers = [];


  //OSMタイルを読み込みベースマップとして表示
  const tileLayer = new TileLayer({
    id: "tile-layer",
    data: "https://api.mapbox.com/styles/v1/mapbox/dark-v10/tiles/512/{z}/{x}/{y}@2x?access_token=pk.eyJ1Ijoic2hpbWl6dSIsImEiOiJjbGZwbDg3YnUwYWV2M3FubDdvN3pqcDhxIn0.WfKF0oFWPFqS6xn0Mm0Yow",
    minZoom: 0,
    maxZoom: 19,
    tileSize: 256,

    renderSubLayers: (props) => {
      const {
        bbox: { west, south, east, north }
      } = props.tile;

      return new BitmapLayer(props, {
        data: null,
        image: props.data,
        bounds: [west, south, east, north]
      });
    }
  });

  layers.push(tileLayer)


  if (selectPoint){
    const scatterlayer = new ScatterplotLayer({
      id: 'scatterplot-layer',
      data: [selectPoint],
      pickable: true,
      opacity: 0.8,
      stroked: true,
      filled: true,
      radiusScale: 1,
      radiusMinPixels: 6,
      lineWidthMinPixels: 3,
      getPosition: d => [d[0], d[1]],
      getRadius: 10,
      getFillColor: d => [255, 0, 0, 180],
      getLineColor: d => [255, 0, 0]
    });

    layers.push(scatterlayer)
  }



  Object.keys(tiffData).forEach((key,i) =>{

    const img = convertDemTiffData(tiffData[key].data, tiffData[key].width, tiffData[key].height);

    const terrain = new TerrainLayer({
      id: "terrain"+i,
      elevationDecoder: {
        "rScaler": 6553.6,
        "gScaler": 25.6,
        "bScaler": 0.1,
        "offset": -10000
      },
      pickable: true,
      autoHighlight: true,
      highlightColor: [255, 0, 0, 255],
      elevationData: img,
      texture: tiffData[key].texture,
      bounds: tiffData["fuji"].bbox,
      _subLayerProps: {
        mesh: {
          getTranslation: translate[key]
        }
      }
    });

    terrain.latlng = latlng[key]
    layers.push(terrain)

  })




  const testlayer = new TextLayer({
    id: 'text-layer',
    data: textData,
    pickable: true,
    getPosition: d => d.coordinates,
    getText: d => {
      return d.label
    },
    getColor:[255, 255,255],
    getSize: 20,
    getAngle: 0,
    getTextAnchor: 'middle',
  });

  layers.push(testlayer)

  //レイヤーの重なり順を配列で指定(先頭のレイヤーが一番下になる)
  return layers;
}
